export default __webpack_public_path__ + "static/media/2.c3e10b46.jpg";